import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  FDHeadlineText, FDBigPicklistInput, FDTitleText, FDBodyText,
} from '@facet-wealth/design';
import { withComponentArray } from 'Helpers/MetaOverride';
import { MarriageMismatchAlert, PlannerAlert } from './Layout/alerts';
import { Disclosure } from '../Components/Disclosure';

export default buildFacetDesignOverride()
  .typeOverride('multipicklist', {
    _component: () => FDBigPicklistInput,
    _customProps: { multiple: true, helperText: '' },
  }, overrideReadOnly)
  .typeOverride('picklist', {
    _component: () => FDBigPicklistInput,
    _customProps: { multiple: false, helperText: '' },
  }, overrideReadOnly)
  .nameOverride('title', {
    _component: () => FDHeadlineText,
    _customProps: {
      size: 'lg',
      color: 'textSecondary',
    },
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => withComponentArray(FDTitleText),
    _customProps: {
      color: 'textSecondary',
      size: 'sm',
    },
  }, overrideReadOnly)
  .nameOverride('questionText', {
    _component: () => FDBodyText,
    _customProps: {
      size: 'md',
    },
  }, overrideReadOnly)
  .nameOverride(['disclosure', 'externalDisclosure'], {
    _component: () => Disclosure,
  }, overrideReadOnly)
  .nameOverride('body', {
    _component: () => withComponentArray(FDBodyText),
  }, overrideReadOnly)
  .nameOverride('plannerAlert', {
    _component: () => PlannerAlert,
  }, overrideReadOnly)
  .nameOverride('marriageMismatchAlert', {
    _component: () => MarriageMismatchAlert,
  }, overrideReadOnly);
